const policyRewriteStatus = {
    INVALID : 0,

    DRAFT : 1,

    SUBMITTED : 2,

    PENDING_ISSUANCE : 3,

    ISSUED : 4,

    INVALID_RATING : 7,

    VALID_RATING : 8,

    VALID_PRICING : 9

};

angular.module('gw-um-j2js')
    .constant('policyRewriteStatus', policyRewriteStatus);